import PropTypes from 'prop-types';

export const ACCORDION_CONTEXT_TYPES = {
  collapseAll: PropTypes.func,
  expandAll: PropTypes.func,
  expanded: PropTypes.shape({}),
  handleKeyDown: PropTypes.func,
  manager: PropTypes.shape({}),
  registerItem: PropTypes.func.isRequired,
  toggle: PropTypes.func,
  unregisterItem: PropTypes.func.isRequired,
};

export const ACCORDION_ITEM_TYPES = {
  accordion: PropTypes.shape(ACCORDION_CONTEXT_TYPES),
  allowMultiple: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      action: PropTypes.string,
      content: PropTypes.string,
      control: PropTypes.string,
      item: PropTypes.string,
      panel: PropTypes.string,
      trigger: PropTypes.string,
    }),
  ]),
  content: PropTypes.node,
  disabled: PropTypes.bool,
  extraAction: PropTypes.node,
  id: PropTypes.string.isRequired,
  label: PropTypes.node,
  onKeyDown: PropTypes.func,
  onToggle: PropTypes.func,
  optimizeRender: PropTypes.bool,
  renderOnExpand: PropTypes.bool,
};

export const ACCORDION_ITEM_DEFAULTS = {
  allowMultiple: false,
  children: null,
  className: {
    action: '',
    content: '',
    control: '',
    item: '',
    panel: '',
    trigger: '',
  },
  content: null,
  disabled: false,
  extraAction: null,
  label: null,
  optimizeRender: false,
  renderOnExpand: false,
};

export const ACCORDION_VIEW_TYPES = {
  accordion: PropTypes.shape(ACCORDION_CONTEXT_TYPES),
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  className: PropTypes.string,
  contextRef: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape(ACCORDION_ITEM_TYPES)),
  render: PropTypes.func,
};

export const ACCORDION_VIEW_DEFAULTS = {
  children: null,
  className: '',
  items: [],
};
